import React from 'react';
import { FlameIcon } from 'lucide-react';
export function TopBar() {
  return <div className="w-full border-b border-naranja/30 bg-naranja/15" data-id="element-194" data-mp="2335b9hf9w46d">
      <p className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-5 py-2 text-center text-[11px] font-bold uppercase tracking-[0.12em] text-naranja-soft sm:text-xs" data-id="element-195" data-mp="234zyj2e0o8dm">
        <FlameIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-196" data-mp="1t6adx1uqk9to" />
        Oferta de lanzamiento cierra pronto · No vuelve a este precio
      </p>
    </div>;
}